import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class CreditNote {
  async fetch(page, perpage, all = false, search) {
    let param = all ? "all=true" : `page=${page}&perPage=${perpage}`;
    if (search) {
      param += `&search=${encodeURIComponent(search)}`;
    }
    const response = await ajaxService.get(
      `/invoices/credit-notes?${param}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async getPDF(id) {
    const response = await ajaxService.get(`/invoices/credit-notes/pdf/${id}`
    );
    if (response ?? false) {
      return response;
    }
  }
  async addCreditNote(data) {
    const response = await ajaxService.post(`/invoices/credit-notes`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const creditNoteService = new CreditNote();
export default creditNoteService;
